"use client"
/* */
const heading = "flow--heading";
const dark = "flow--heading--dark";
const light = "flow--heading--light";
const headingText = "flow--heading--heading-text";
const icon = "flow--heading--icon";
const headingContent = "flow--heading--heading-content";
const xs = "flow--heading--xs";
const s = "flow--heading--s";
const m = "flow--heading--m";
const l = "flow--heading--l";
const xl = "flow--heading--xl";
const xxl = "flow--heading--xxl";
const styles = {
	heading: heading,
	dark: dark,
	light: light,
	headingText: headingText,
	icon: icon,
	headingContent: headingContent,
	xs: xs,
	s: s,
	m: m,
	l: l,
	xl: xl,
	xxl: xxl,
	"wrap-wrap": "flow--heading--wrap-wrap",
	"wrap-balance": "flow--heading--wrap-balance"
};

export { dark, styles as default, heading, headingContent, headingText, icon, l, light, m, s, xl, xs, xxl };
//# sourceMappingURL=Heading.module.scss.mjs.map
